import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { SELECTED_PRODUCTS } from '../constants';
import { SelectProductsTable } from './select-products-table/select-products-table';

import { messages } from './messages';

export const SelectProductsReadOnly = ({ stepPayload }) => {
  const selectedProducts = stepPayload[SELECTED_PRODUCTS];
  const productCount = selectedProducts?.length || 0;

  if (productCount === 0) {
    return null;
  }

  return (
    <>
      <Text formattedMessageValues={{ productCount }} textType={TextType.Label} value={messages.readOnlyProductCount} />
      <SelectProductsTable data={selectedProducts} isReadOnly />
    </>
  );
};
